export function isAssumptionLoanAccountNumber(accountNumber: string): boolean {
  return accountNumber.trim().includes("-");
}
